import styled from 'styled-components';
import { Modal, Selector, CheckButton, IconButton } from '../../../components';

export const StyledModal = styled(Modal)`
  width: 536px;
  min-height: 339px;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContainerBody = styled.div`
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  flex: 1;
`;

export const ContainerFooter = styled.div`
  padding: 20px 5px 0px 0px;
  font-size: 1.1rem;
`;

export const Title = styled.div`
  width: 100%;
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.editorModalTextColor};
`;

export const Label = styled.span`
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 10px;
  display: block;
  color: ${(props) => props.theme.colors.editorModalTextColor};
`;

export const StaticText = styled.span`
  font-size: 1.2em;
  margin-bottom: 10px;
  font-style: oblique;
  display: block;
  padding: 0px 5px;
`;

export const StyledSelector = styled(Selector)`
`;

export const UsersList = styled.ul`
  width: 100%;
  border-collapse: collapse;
`;

export const UsersListItem = styled.li`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.card.listItemsTextColor};
  font-size: 1.2rem;
  font-weight: 300;
  padding: 10px 5px;
  border-bottom: 1px solid ${(props) => props.theme.colors.diviserSmoothColor}; 
`;

export const UsersListItemName = styled.span`
  flex: 1;
`;

export const StyledCheckButton = styled(CheckButton)`
  color: ${(props) => props.theme.colors.editorModalTextColor};
`;
